import PrepaidCardInfo from '@components/prepaid/PrepaidCardInfo';
import { css } from '@emotion/react';
import useFullHeight from '@hooks/ui/useFullHeight';
import { useRef } from 'react';
import { Index, List, ListRowRenderer } from 'react-virtualized';

import usePrepaidCardTransactions
    from './hooks/usePrepaidCardTransactions';
import useWidth from './hooks/useWidth';
import LogItem from './LogItem';
import Period from './Period';

interface Props {
  id: string;
}

const INFO_HEIGHT = 124;
const PERIOD_HEIGHT_PX = 75;
const ITEM_HEIGHT_PX = 151;
const ITEM_HEIGHT_SM_PX = 146;
const FIRST_ITEM_PADDING_TOP_PX = 20;

function LogItems({ id }: Props) {
    const height = useFullHeight();
    const wrapperRef = useRef<HTMLDivElement>(null);
    const {
        transactions, changePeriod, period,
    } = usePrepaidCardTransactions({ id });
    console.log({ transactions });
    const rowRenderer: ListRowRenderer = ({ index, style }) => {
        if (index === 0) {
            return (<PrepaidCardInfo key='cardInfo'
                cardId={id}/>);
        }
        if (index === 1) {
            return <Period key='period'
                style={style}
                period={period}
                setPeriod={changePeriod}/>;
        }
        return <LogItem transaction={transactions![index - 2]}
            isFirst={index === 2}
            key={`transaction ${index}`} style={style}/>;
    };
    const rowHeight = ({ index }: Index): number => {
        if (index === 0) {
            return INFO_HEIGHT;
        }
        if (index === 1) {
            return PERIOD_HEIGHT_PX;
        }
        console.log({ index });

        const log = transactions![index - 2];
        const isSm = ['CHARGED', 'CHARGE_CANCELED'].includes(log.type);
        const paddingTop = index === 2 ? FIRST_ITEM_PADDING_TOP_PX : 0;
        return (isSm ? ITEM_HEIGHT_SM_PX : ITEM_HEIGHT_PX) + paddingTop;
    };
    const width = useWidth(wrapperRef);
    return (
        <div style={{ width: '100%' }} ref={wrapperRef}>
            <List height={height}
                css={css`
                    max-width: var(--max-view-port-width);
                    padding-bottom: 48px;
                    width: 100%;
                `}
                rowHeight={rowHeight}
                rowCount={(transactions?.length || 0) + 2}
                width={width}
                rowRenderer={rowRenderer}/>
        </div>

    );
}

export default LogItems;
